import CalendarService from '../lib/services/CalendarService';
import { injectLogos } from '../lib/utils';

const fetchStockSplits = (params = {}, injectTickersLogos = true, pageSize = 1000): Promise<any> => {
  const query = {
    ...params,
    pagesize: pageSize,
    'parameters[date_search_field]': 'ex',
    'parameters[date_sort]': 'ex',
  };

  const Calendar = new CalendarService();

  return Calendar.getSplits(query).then(({ data }: any) => {
    const items: any = [];
    if (Array.isArray(data.splits) && data.splits.length) {
      return injectTickersLogos ? injectLogos(data.splits) : data.splits;
    }
    return items;
  });
};

export { fetchStockSplits };
